import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app/store.js'
import auth from './modules/auth/store.js'
import devices from './modules/devices/store.js'
import children from './modules/children/store.js'
import feed from './modules/feed/store.js'
import categories from './modules/categories/store.js'
import geofence from './modules/geofence/store.js'
import requests from './modules/requests/store.js'
import vuexLocalStorage from './plugins/persist'

Vue.use(Vuex)

const debug = Vue.config.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    app,
    auth,
    devices,
    children,
    feed,
    categories,
    geofence,
    requests
  },

  plugins: [
    vuexLocalStorage.plugin
  ],

  strict: debug
})
